export const urls = {
  auth: {
    login: 'login',
    forgotPassword: 'forgot-password',
    changePassword: 'change-password',
    confirmOtp: 'confirm-otp',
    resetPassword: 'reset-password',
    register:'register',
    //validateEmail:'register/validate-email',
    //validateCompanyEmail:'register/validate-company-email',
    confirmEmail:'register/confirm-email',
    resendEmailConfirmation:'register/resend-confirmation-code',
    registerDetail:'register/details',
    verifyDiscount:'register/verify-discount-code',
    registerPayment:'register/payment',
    confirmPayment:'register/payment-confirm',
    preparePayment:'register/payment/prepare',
    confirmPaymentDirectly:'register/direct-payment-confirm',
    cardConfirm:'register/card-confirm',
    companies:'companies',
    registerPaymentDirectly:'register/direct-payment',
    validateAllFields:'register/validate-fields'
  },
  user: {
    users: 'users',
    retrieve: 'retrieve',
    pairCompany: 'pair-company'
  },
  company: {
    companies: 'companies',
    validateGptKey: 'company/validate-gpt-key',
    //validateEmail: 'company/validate-email',
    //validateCompanyEmail: 'company/validate-company-email',
    validatePhone: 'company/validate-phone',
    searchByName: 'company/search',
    countryList: 'countries/list'
  },
  documents: {
    documents: 'documents',
    uploadConfirm: 'upload/confirm'
  },
  chats: {
    chats: 'chats',
    regenerateMessage: 'regenerate-message',
    message: 'message',
    reference: 'reference'
  },
  appInformation: {
    appInformation: 'app-information'
  },
  termsConditions: {
    termsConditions: 'terms-and-conditions',
    termsConditonsByUser: 'term-and-condition-users',
    acceptTermsConditions: 'accept'
  },
  privacyPolicies: {
    privacyPoliciesByUser: 'privacy-policy-users',
    privacyPolicies: 'privacy-policies'
  },
  marketing: {
    marketingByUser: 'marketing-users',
    acceptMarketing: 'accept'
  },
  profile: {
    profile: 'profile',
    me: 'me',
    avatar: 'avatar'
  },
  detailCase: {
    cases: 'cases',
    chatList: 'chats',
    statusList: 'case-statuses',
    documentList: 'documents',
    processedList: 'processed',
    notes: 'notes'
  },
  notes: {
    notes: 'notes',
    export: 'export'
  },
  regulations: {
    regulations: 'regulations',
    regulation: 'regulation',
    chats: 'chats'
  },
  subscriptions:{
    tiersList:'get/tiers',
    paymentCards:'payment-cards',
    paymentCards3dSecure:'payment-card/confirm',
    paymentCard:'payment-card',
    setDefault:'set-default',
    orders:'subscription-payment-history',
    requestBill:'request-bill',
    listPaymentCards:'list-payment-cards',
    cancelSubscription:'request-cancel-subscription',
    reactivateSubscription:'reactivate-subscription',
    updateSubscription:'request-update-subscription',
    newParamsForSubscription:'new-params-for-subscription'
  }

}
